// extracted by mini-css-extract-plugin
export default {"wrapper":"CommonCard_wrapper__yIgeB"};